import type { SVGProps } from 'react';
import type { SVGRType } from '../types';

const SvgBellActive = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRType) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 40 40'
    width='40'
    height='40'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M9 25.7999C9 26.7356 9.69892 27.3668 10.86 27.3668H28.8628C30.0127 27.3668 30.7229 26.7356 30.7229 25.7999C30.7229 24.6458 29.6834 23.6418 28.6911 22.6833C28.6656 22.6587 28.6402 22.6342 28.6148 22.6097C27.8934 21.8995 27.6792 20.434 27.5777 19.1714C27.5439 18.4387 27.4876 17.7398 27.3974 17.0634C26.8112 17.3114 26.1574 17.458 25.481 17.458C22.4711 17.458 20.0023 14.9892 20.0023 11.9793C20.0023 10.5928 20.5322 9.3302 21.3889 8.37201C20.938 8.124 20.4194 8 19.8558 8C18.1874 8 16.9699 9.13856 16.5077 10.6266C13.5768 11.6862 12.3706 14.6059 12.2128 18.7543C12.0775 20.2311 11.8859 21.8431 11.0968 22.6097C11.08 22.6259 11.0631 22.6422 11.0463 22.6584C10.0466 23.6244 9 24.6359 9 25.7999ZM16.271 28.9338C16.4176 30.5796 17.8718 32 19.8671 32C21.8511 32 23.3053 30.5796 23.4519 28.9338H16.271Z'
    />
    <circle cx='26' cy='12' r='4' fill='#EB4553' />
  </svg>
);

export default SvgBellActive;
